/* unplugin-vue-components disabled */import { render } from "./ChapterWideScreenMsg.vue?vue&type=template&id=1e56f306&scoped=true&ts=true"
import script from "./ChapterWideScreenMsg.vue?vue&type=script&lang=ts"
export * from "./ChapterWideScreenMsg.vue?vue&type=script&lang=ts"

import "./ChapterWideScreenMsg.vue?vue&type=style&index=0&id=1e56f306&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e56f306"]])

export default __exports__